var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',_vm._b({},'base-form',Object.assign({}, _vm.settings),false),[_c(_vm.input,{tag:"component",staticClass:"gocc__authentication__form__field",attrs:{"settings":{
            label: { class: 'field__label--hide', text: _vm.$t('global.email') },
            input: {
                component: 'InputBasic',
                id: 'email',
                name: 'email',
                type: 'text',
                class: 'gocc__authentication__form__field__input',
                value: '',
                placeholder: _vm.$t('global.email'),
                isRequired: true,
                fileValidation: 'basicEmail',
                errors: [{
                    type: 'email', warning: _vm.$t('error.email')
                }],
                isMissing: '',
                noListener: true
            },
            allowFilling: true
        }}}),_c('div',{staticClass:"gocc__authentication__form__field--margin"},[_c('submission-handler',[_c(_vm.button,{tag:"component",staticClass:"gocc__authentication__form__button background--green color--white",attrs:{"type":"submit"},domProps:{"innerHTML":_vm._s(_vm.$t('global.ask'))}})],1)],1),_c('router-link',{staticClass:"gocc__authentication__form__anchor gocc__authentication__form__back display--block color--green capitalize",attrs:{"to":"/authentication/login","activeClass":"active"}},[_vm._v(" "+_vm._s(_vm.$t('authentication.back'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }